import { useEffect } from 'react';
import { Backdrop, CircularProgress, CssBaseline } from '@material-ui/core';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@material-ui/core/styles';
import { ErrorBoundary, Bugsnag } from 'src/helpers/bugsnag';

import { useDispatch, useSelector } from 'react-redux';
import authActions from 'src/store/Auth/actions';

import { history } from 'src/store';
import theme from 'src/assets/theme';

import Login from './Public/Login';
import Private from './Private';
import { cookies } from 'src/helpers';

function App() {
	const dispatch = useDispatch();
	const isAuth = useSelector(state => state.auth.isAuth)
	const user = useSelector(state => state.auth.data)
	const isLoading = useSelector(state => state.auth.isLoading)
	const token = cookies.get('auth')

	useEffect(() => {
		if (token)
			dispatch(authActions.me())
	}, [])

	useEffect(() => {
		if (user?.id) {
			Bugsnag.setUser(
				user.id,
				user.email,
				user.username
			)
		}
	}, [user?.id])

	if (isLoading) {
		return (
			<Backdrop open={isLoading} style={{ zIndex: 1000 }}>
				<CircularProgress color="inherit" />
			</Backdrop>
		)
	}

	return (
		<ErrorBoundary>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<SnackbarProvider
					anchorOrigin={{
						horizontal: 'right',
						vertical: 'bottom',
					}}
					maxSnack={3}
				>
					<Router history={history}>
						<Switch>

							{token || isAuth ? (
								<>
									<Route
										component={Private}
										path={'/app'}

									/>

									<Redirect to="/app/home" />
								</>
							) : (
								<>
									<Route
										component={Login}
										exact
										path={'/'}
									/>

									<Route
										component={Login}
										exact
										path={'/login'}
									/>

									<Redirect to="/" />
								</>
							)}

						</Switch>
					</Router>
				</SnackbarProvider>
			</ThemeProvider>
		</ErrorBoundary>
	);
}

export default App;
